import { format } from "date-fns";

type RequestParams = Record<string, unknown>;

interface DateRangeParam {
  date_from?: string | number | Date | null;
  date_to?: string | number | Date | null;
}

const isDateRangeParam = (value: unknown): value is DateRangeParam =>
  typeof value === "object" && value !== null;

const getOptionValue = (value: unknown): unknown => {
  if (typeof value === "object" && value !== null && "value" in value) {
    return value.value;
  }

  return value;
};

export class RequestUtils {
  public static parseParams(rawFilters: RequestParams): RequestParams {
    let payload = { ...rawFilters };
    payload = this.parseDates(payload);
    payload = this.parseArrays(payload);
    return payload;
  }

  private static parseDates(rawFilters: RequestParams): RequestParams {
    const { date_range, ...rest } = rawFilters;
    const filters: RequestParams = rest;
    if (isDateRangeParam(date_range) && date_range.date_from) {
      try {
        filters.date_from = format(
          new Date(date_range.date_from),
          "yyyy-MM-dd"
        );
      } catch {
        filters.date_from = null;
      }
    }
    if (isDateRangeParam(date_range) && date_range.date_to) {
      try {
        filters.date_to = format(new Date(date_range.date_to), "yyyy-MM-dd");
      } catch {
        filters.date_to = null;
      }
    }
    return filters;
  }

  private static parseArrays(rawFilters: RequestParams): RequestParams {
    const filters: RequestParams = {};
    Object.entries(rawFilters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        filters[key] = value.map(getOptionValue);
      } else {
        filters[key] = value;
      }
    });

    return filters;
  }
}
